import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initializeLanguage } from './i18n';
import { initCrossWindowSync } from './utils/crossWindowSync';

// 言語設定を初期化
initializeLanguage();

// 別ウィンドウ・別タブでのストア変更を反映（Electronマスコット⇔メインアプリの購入同期等）
initCrossWindowSync();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
